export default {
  // GET Request //

  // Gets all user data
  async getAdminData(context, userId) {
    const token = context.rootGetters["authData/token"];
    let response;

    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/admin/retrieve/" + userId,
        {
          method: "GET",
          headers: { Authorization: "Bearer " + token },
        }
      );
      response = await response.json();
    } catch (err) {
      return 500;
    }

    context.commit("adminData", {
      adminId: response.adminId,
      companyId: response.companyId,
    });

    context.commit(
      "userData/userData",
      {
        userId: response.adminId,
        firstName: response.firstName,
        lastName: response.lastName,
        companyId: response.companyId,
        emailAddress: response.emailAddress,
        roleId: response.roleId,
        profilePicture: response.profilePicture || null,
      },
      { root: true }
    );

    context.commit("userData/userLoaded", null, { root: true });
    return 200;
  },
  // Gets all user data
  async getAccountData(context) {
    const token = context.rootGetters["authData/token"];
    let companies;
    let users;

    try {
      companies = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/company/retrieve-all",
        {
          method: "GET",
          headers: { Authorization: "Bearer " + token },
        }
      );
      companies = await companies.json();

      users = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/user/retrieve-all",
        {
          method: "GET",
          headers: { Authorization: "Bearer " + token },
        }
      );
      users = await users.json();
    } catch (err) {
      return 500;
    }

    context.commit("accountsData", {
      companies: companies,
      users: users,
    });
    context.commit("accountsTimestamp");
    return 200;
  },
  // Gets company data
  async getCompanyData(context, companyId) {
    const token = context.rootGetters["authData/token"];
    let billing;
    let invoices;
    let users;

    try {
      billing = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/billing/retrieve/" + companyId,
        {
          method: "GET",
          headers: { Authorization: "Bearer " + token },
        }
      );
      billing = await billing.json();

      invoices = await fetch(
        process.env.VUE_APP_NODE_SERVER +
          "/billing/retrieve-invoices/" +
          companyId,
        {
          method: "GET",
          headers: { Authorization: "Bearer " + token },
        }
      );
      invoices = await invoices.json();

      users = await fetch(
        process.env.VUE_APP_NODE_SERVER +
          "/user/retrieve-by-company-id/" +
          companyId,
        {
          method: "GET",
          headers: { Authorization: "Bearer " + token },
        }
      );
      users = await users.json();
    } catch (err) {
      return { status: 500 };
    }

    var currencySymbol;
    // Determines the currency code
    if (["AUD", "USD"].includes(billing.subscription.currency_code)) {
      currencySymbol = "$";
    }

    // Checks if card object exists
    var cardObject = {};
    if (billing.card) {
      cardObject = {
        status: billing.card.status,
        maskedNumber: billing.card.masked_number,
        last4: billing.card.last4,
        cardType: billing.card.card_type,
        expiryMonth: billing.card.expiry_month,
        expiryYear: billing.card.expiry_year,
      };
    }

    let billingAddress;
    if (billing.customer.billing_address) {
      billingAddress = {
        firstName: billing.customer.billing_address.first_name,
        lastName: billing.customer.billing_address.last_name,
        emailAddress: billing.customer.billing_address.email_address,
        billingPhone: billing.customer.billing_address.billing_phone,
        streetAddress: billing.customer.billing_address.street_address,
        city: billing.customer.billing_address.city,
        state: billing.customer.billing_address.state,
        zipcode: billing.customer.billing_address.zipcode,
      };
    }

    let billingObject = {
      accountLocked: billing.subscription.status == "cancelled" ? true : false,
      unbilledCharges: billing.customer.unbilled_charges,
      paymentMethod: billing.customer.payment_method,
      taxability: billing.customer.taxability,
      nextBillingAt: billing.subscription.next_billing_at,
      promotionalCredits: billing.customer.promotional_credits,
      billingPeriodUnit: billing.subscription.billing_period_unit,
      currencySymbol: currencySymbol,
      currencyCode: billing.subscription.currency_code,
      status: billing.subscription.status,
      unpaidCharges: {
        dueInvoiceCount: billing.subscription.due_invoices_count,
        totalDues: billing.subscription.total_dues,
        dueSince: billing.subscription.due_since,
      },
      billingAddress: billingAddress,
      storedCard: cardObject,
    };

    return {
      status: 200,
      companyId: companyId,
      billing: billingObject,
      invoices: invoices,
      users: users,
    };
  },
  // Gets company data
  async getUserData(context, userId) {
    const token = context.rootGetters["authData/token"];
    let response;

    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/user/retrieve/" + userId,
        {
          method: "GET",
          headers: { Authorization: "Bearer " + token },
        }
      );
      response = await response.json();
    } catch (err) {
      return { status: 500 };
    }

    return {
      status: 200,
      companies: response.companies,
    };
  },

  // POST Requests

  // Create a new company
  async postCreateCompany(context, payload) {
    const token = context.rootGetters["authData/token"];
    let response;

    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/company/create",
        {
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyName: payload.companyName,
            countryCode: payload.countryCode,
            companyType: payload.companyType,
            companyDomain: payload.companyDomain,
            allowAddUser: payload.allowAddUser,
            businessNumber: payload.businessNumber,
            crmId: payload.crmId,
            firstName: payload.firstName,
            lastName: payload.lastName,
            emailAddress: payload.emailAddress,
            password: payload.password,
            freeTrialDate: payload.freeTrialDate,
          }),
        }
      );
      response = await response.json();
    } catch (err) {
      return 500;
    }

    let companyPayload = context.state.companies;
    companyPayload.push(response.company);
    context.commit("companyData", companyPayload);

    let userPayload = context.state.users;
    userPayload.push(response.user);
    context.commit("userData", userPayload);

    return 201;
  },
  // Create new user in account
  async postCreateUser(context, payload) {
    const token = context.rootGetters["authData/token"];
    let response;
    var bodyContent = {
      companyId: payload.companyId,
      firstName: payload.firstName,
      lastName: payload.lastName,
      emailAddress: payload.emailAddress,
      phoneNumber: payload.phoneNumber,
      startDate: payload.startDate,
      freeTrialDate: payload.freeTrialDate,
      type: payload.type,
      managerId: payload.managerId || null,
      companyTitle: payload.companyTitle || null,
      locationId: payload.locationId || null,
      departmentId: payload.departmentId || null,
      password: payload.password,
      role: payload.role,
      countryCode: payload.countryCode,
    };

    if (payload.companyTitle != "") {
      bodyContent.companyTitle = payload.companyTitle;
    }

    try {
      response = await fetch(process.env.VUE_APP_NODE_SERVER + "/user/create", {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify(bodyContent),
      });
      response = await response.json();
    } catch (err) {
      return { status: 500 };
    }

    let userObject = {
      userId: response.userId,
      firstName: response.firstName,
      lastName: response.lastName,
      type: response.type,
      fullName: response.firstName + " " + response.lastName,
      emailAddress: response.emailAddress,
      roleId: response.roleId,
      phoneNumber: response.phoneNumber,
      profilePicture: null,
      countryCode: response.countryCode,
      createdAt: response.createdAt,
    };

    var updatedUsers = context.state.users;
    updatedUsers.push(userObject);
    context.commit("userData", updatedUsers);

    userObject.status = 201;
    return userObject;
  },
  // Adds general user to company
  async postAddToCompany(context, payload) {
    const token = context.rootGetters["authData/token"];
    try {
      await fetch(process.env.VUE_APP_NODE_SERVER + "/user/add-to-company", {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          companyId: payload.companyId,
          userId: payload.userId,
          companyTitle: payload.companyTitle,
          startDate: payload.startDate,
        }),
      });
    } catch (err) {
      return { status: 500 };
    }

    return {
      status: 200,
      companyId: payload.companyId,
      userId: payload.userId,
    };
  },
  // PATCH Routes //

  // Update company
  async patchCompany(context, payload) {
    const token = context.rootGetters["authData/token"];
    let response;
    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/company/update",
        {
          method: "PATCH",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: payload.companyId,
            companyName: payload.companyName,
            streetAddress: payload.streetAddress,
            city: payload.city,
            state: payload.state,
            zipcode: payload.zipcode,
            phoneNumber: payload.phoneNumber,
            businessNumber: payload.businessNumber,
            allowAddUser: payload.allowAddUser,
            status: payload.status,
            crmId: payload.crmId,
            companyDomain: payload.companyDomain,
          }),
        }
      );
      response = await response.json();
    } catch (err) {
      return { response: 500 };
    }

    let company = {
      companyId: response.companyId,
      companyName: response.companyName,
      countryCode: response.countryCode,
      companyType: response.companyType,
      companyDomain: response.companyDomain,
      businessNumber: response.businessNumber,
      allowAddUser: response.allowAddUser,
      status: response.status,
      primaryUserId: response.primaryUserId,
      streetAddress: response.headOfficeAddress.streetAddress,
      city: response.headOfficeAddress.city,
      state: response.headOfficeAddress.state,
      zipcode: response.headOfficeAddress.zipcode,
      crmId: response.crmId,
      phoneNumber: response.phoneNumber,
      createdAt: response.createdAt,
    };

    let companyPayload = context.state.companies;
    for (let i = 0; i < companyPayload.length; i++) {
      if (companyPayload[i].companyId == company.companyId) {
        companyPayload[i] = company;
        break;
      }
    }
    context.commit("companyData", companyPayload);

    company.response = 200;
    return company;
  },
  // Update user password
  async patchUserPassword(context, payload) {
    const token = context.rootGetters["authData/token"];

    try {
      await fetch(process.env.VUE_APP_NODE_SERVER + "/user/update-password", {
        method: "PATCH",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          userId: payload.userId,
          password: payload.password,
        }),
      });
    } catch (err) {
      return 500;
    }

    return 200;
  },

  // DELETE Routes //

  // Remove user from company
  async deleteRemoveUserFromCompany(context, payload) {
    const token = context.rootGetters["authData/token"];
    try {
      await fetch(
        process.env.VUE_APP_NODE_SERVER + "/user/remove-from-company",
        {
          method: "DELETE",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: payload.companyId,
            userId: payload.userId,
          }),
        }
      );

      await fetch(
        process.env.VUE_APP_NODE_MESSENGER_SERVER +
          "/account/remove-user-resources-in-company",
        {
          method: "DELETE",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: payload.companyId,
            userId: payload.userId,
          }),
        }
      );
    } catch (err) {
      return 500;
    }

    return 201;
  },
  // Deletes user
  async deleteUser(context, payload) {
    const token = context.rootGetters["authData/token"];
    let response;
    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/user/delete-user/" + payload.userId,
        {
          method: "DELETE",
          mode: "cors",
          headers: { Authorization: "Bearer " + token },
        }
      );
      response = await response.json();

      await fetch(
        process.env.VUE_APP_NODE_MESSENGER_SERVER +
          "/account/remove-user-resources",
        {
          method: "DELETE",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            userId: payload.userId,
          }),
        }
      );
    } catch (err) {
      return 500;
    }

    const updatedUsers = context.state.users.filter(
      (user) => user.userId != response.userId
    );
    context.commit("userData", updatedUsers);
    return 201;
  },
  // Deletes company and resources
  async deleteCompany(context, payload) {
    const token = context.rootGetters["authData/token"];
    try {
      await fetch(
        process.env.VUE_APP_NODE_SERVER +
          "/company/delete-company/" +
          payload.companyId,
        {
          method: "DELETE",
          mode: "cors",
          headers: { Authorization: "Bearer " + token },
        }
      );

      await fetch(
        process.env.VUE_APP_NODE_MESSENGER_SERVER +
          "/account/remove-company-resources",
        {
          method: "DELETE",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: payload.companyId,
          }),
        }
      );
    } catch (err) {
      return 500;
    }

    return 201;
  },
};
